import { t, useI18n } from "@bookingcom/lingojs-react";
import React, { ReactNode } from "react";

type Props = {
  index: number;
  children: ReactNode;
};

const FlightCardWrapper = ({ index, children }: Props) => {
  const i18n = useI18n();

  return (
    <div id={`flightcard-${index}`} data-testid="searchresults_card">
      <div role="group" aria-label={i18n.trans(t("a11y_flights_search_card_begin"))}>
        {children}
      </div>
    </div>
  );
};

export default FlightCardWrapper;
